import { createContext } from 'react';
import { AnalyticsContextValue } from '../types/analytics.types';

export const AnalyticsContext = createContext<AnalyticsContextValue | null>(null);
